import { render, staticRenderFns } from "./TeleMedecine.vue?vue&type=template&id=99e6093e&scoped=true"
import script from "./TeleMedecine.vue?vue&type=script&lang=js"
export * from "./TeleMedecine.vue?vue&type=script&lang=js"
import style0 from "./TeleMedecine.vue?vue&type=style&index=0&id=99e6093e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99e6093e",
  null
  
)

export default component.exports